<div class="{{localService.selectedLanguageCode}}" *ngIf="localService.languageContent">
  <div style="display:none">
    <button (click)="onOpenWhitelist()" class="force_click_after_load"></button>
  </div>
</div>
